import { render, staticRenderFns } from "./FiltersContent.vue?vue&type=template&id=68cafebe&scoped=true"
import script from "./FiltersContent.vue?vue&type=script&lang=js"
export * from "./FiltersContent.vue?vue&type=script&lang=js"
import style0 from "./FiltersContent.vue?vue&type=style&index=0&id=68cafebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cafebe",
  null
  
)

export default component.exports